export default "/fonts/vendor/socicon/socicon.eot?ec23f2c6ea40d7043ca801b27f5788e8";